import { Alert } from '@mui/material';
import type { ValidationErrors } from './jobEndValidation';

interface ValidationSummaryBannerProps {
  validationErrors: ValidationErrors;
  showNatureOfRole: boolean;
  showSkillRatings: boolean;
}

export function ValidationSummaryBanner({
  validationErrors,
  showNatureOfRole,
  showSkillRatings,
}: ValidationSummaryBannerProps) {
  const messages: string[] = [];

  if (validationErrors.natureOfRole && showNatureOfRole) {
    messages.push('Nature of Role \u2014 all ratings must be completed');
  }
  if (validationErrors.skillRatings && showSkillRatings) {
    messages.push('Ratings by Skill Area \u2014 all ratings must be completed');
  }
  if (validationErrors.strengthsDev) {
    messages.push(
      'Strengths & Development Areas \u2014 at least 3 strengths and 3 development areas are required',
    );
  }
  if (messages.length === 0) return null;

  return (
    <Alert severity="error" sx={{ mb: 3 }}>
      <ul style={{ margin: 0, paddingLeft: 20 }}>
        {messages.map((message) => (
          <li key={message}>{message}</li>
        ))}
      </ul>
    </Alert>
  );
}
